import { Link } from "react-router-dom";
import { Shield, Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-primary-foreground/10 p-2 rounded-lg">
                <Shield className="h-6 w-6" />
              </div>
              <div>
                <h3 className="text-lg font-bold">Blue Knight</h3>
                <p className="text-sm opacity-90">Contracting & Construction</p>
              </div>
            </div>
            <p className="text-sm opacity-90 mb-4">
              Ontario's trusted partner in construction, delivering quality projects across the province with expertise,
              reliability, and craftsmanship.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <span> Call (647) 539-6097</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <span>info@blueknightcontracting.ca</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                <span>200 Suntract Rd Unit 101, North York, ON M9N 2V9</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li>
                <Link to="/services/general-contracting" className="hover:opacity-100 transition-opacity">
                  General Contracting
                </Link>
              </li>
              <li>
                <Link to="/services/skilled-trades" className="hover:opacity-100 transition-opacity">
                  Skilled Trades
                </Link>
              </li>
              <li>
                <Link to="/services/heavy-equipment" className="hover:opacity-100 transition-opacity">
                  Heavy Equipment & Site Work
                </Link>
              </li>
              <li>
                <Link to="/services/specialty-contracting" className="hover:opacity-100 transition-opacity">
                  Specialty Contracting
                </Link>
              </li>
              <li>
                <Link to="/services/design-engineering" className="hover:opacity-100 transition-opacity">
                  Design & Engineering Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-semibold mb-4">Service Areas</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li>
                <Link to="/toronto" className="hover:opacity-100 transition-opacity">
                  Toronto
                </Link>
              </li>
              <li>
                <Link to="/ottawa" className="hover:opacity-100 transition-opacity">
                  Ottawa
                </Link>
              </li>
              <li>
                <Link to="/mississauga" className="hover:opacity-100 transition-opacity">
                  Mississauga
                </Link>
              </li>
              <li>
                <Link to="/hamilton" className="hover:opacity-100 transition-opacity">
                  Hamilton
                </Link>
              </li>
              <li>
                <Link to="/london" className="hover:opacity-100 transition-opacity">
                  London
                </Link>
              </li>
              <li>
                <Link to="/locations" className="hover:opacity-100 transition-opacity">
                  View All Locations
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li>
                <Link to="/about" className="hover:opacity-100 transition-opacity">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:opacity-100 transition-opacity">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:opacity-100 transition-opacity">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/quote" className="hover:opacity-100 transition-opacity">
                  Free Quote
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:opacity-100 transition-opacity">
                  Careers
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Google Map Section */}
        <div className="border-t border-primary-foreground/20 pt-8 mb-8">
          <div className="max-w-4xl mx-auto">
            <h4 className="font-semibold mb-4 text-center">Visit Our Office</h4>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2883.873900568017!2d-79.51136202382003!3d43.7131695710993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b311c6d9b4eeb%3A0x146f8996c9f8a878!2s200%20Suntract%20Rd%20%23101%2C%20Toronto%2C%20ON%20M9N%202V6!5e0!3m2!1sen!2sca!4v1761436382847!5m2!1sen!2sca"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Blue Knight Contracting Office Location"
                className="w-full"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center text-sm opacity-90">
          <p>
            &copy; 2024 Blue Knight Contracting and Construction. All rights reserved. Licensed and insured across
            Ontario.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
